import {isNotEmpty, isNotNil} from 'ramda';

import {appWorkspaceKey, browserStorageKey, OAUTH_CLIENT_ID} from '@dms/config';

import {workspaceInitializeRoute} from '../constants/routes';
import {buildUrl} from './buildUrl';

type RedirectToWorkspaceOptions = {
  currentUserEmail?: string;
};

export const redirectToWorkspace = (options?: RedirectToWorkspaceOptions) => {
  const iamUrl = process.env.IAM_URL;

  if (!iamUrl) {
    throw new Error('IAM_URL is not set');
  }

  const url = new URL(iamUrl);

  const searchParamsConfig = {
    language: localStorage.getItem(browserStorageKey.LAST_KNOWN_LANGUAGE) ?? 'en',
    client_id: OAUTH_CLIENT_ID,
    redirect_uri: buildUrl(workspaceInitializeRoute, appWorkspaceKey, false),
    email: options?.currentUserEmail,
  };

  Object.entries(searchParamsConfig).forEach(([key, value]) => {
    if (isNotNil(value) && isNotEmpty(value)) {
      url.searchParams.set(key, value);
    }
  });

  window.location.href = url.toString();
};
